const notes = `notes {
        author
        dialogPartner
        note
        type
        id
    }`;

export default notes;
